import React, {useMemo, KeyboardEvent} from 'react';
import {localizedWeekDays} from '../../utils/date';
import {keys} from '../../../../constants/KeyCodes';
import direction from '../../styles/direction.module.scss';
import {StringInputProps} from './StringInput';
import {isLtrStyle} from '../../utils/direction';

export const DayInput = ({
    column,
    value,
    handleMouseDown,
    handleChange,
    handleKeyDown,
    inputRef,
    isReadonly,
    searchMode,
    onBlur
}: StringInputProps) => {
    const isLtr = useMemo(() => isLtrStyle(value, column.Type), [value, column]);

    const processKeyDown = (event: KeyboardEvent) => {
        if (!isReadonly) {
            if (event.key === keys.MINUS || event.key === keys.PLUS) {
                event.preventDefault();
                let nextValue;
                if (!value) {
                    const date = new Date();
                    const day = date.getDay();
                    nextValue = localizedWeekDays[day];
                } else {
                    const index = localizedWeekDays.indexOf(value);
                    if (index > -1) {
                        let nextIndex;
                        if (event.key === keys.MINUS) {
                            nextIndex = index === 0 ? localizedWeekDays.length - 1 : index - 1;
                        } else {
                            nextIndex = index === localizedWeekDays.length - 1 ? 0 : index + 1;
                        }
                        nextValue = localizedWeekDays[nextIndex];
                    } else {
                        nextValue = localizedWeekDays[localizedWeekDays.length - 1];
                    }
                }
                handleChange(nextValue);
            }
        }
        handleKeyDown(event);
    };

    const isValidDay = (value: string): boolean => {
        return !!localizedWeekDays.find(day => day.startsWith(value));
    };

    const validateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (searchMode || !value || isValidDay(value)) {
            handleChange(value);
        }
    };

    return (
        <input
            type={'text'}
            maxLength={column.maxLength}
            ref={inputRef}
            value={value}
            onKeyDown={processKeyDown}
            onChange={validateChange}
            readOnly={isReadonly}
            onMouseDown={handleMouseDown}
            className={isLtr ? direction.ltrDirection : direction.rtlDirection}
            onBlur={onBlur}
        />
    );
};
